import type { ComponentType } from 'react';
/**
 * Lazy 로딩 라우트 생성 헬퍼 함수
 * 반복되는 lazy 로딩 패턴을 간소화합니다.
 */
export const createLazyRoute = (importFactory: () => Promise<{ default: ComponentType<any> }>) => ({
  lazy: async () => {
    const component = await importFactory();
    return { Component: component.default };
  },
});

